import {IRootState} from "../store/configureStore";
import {ICameraLive} from "../store/sliceCamera";
import {createSelector} from "@reduxjs/toolkit";


export const getCameras = (state: IRootState): ICameraLive[] =>
    state.websocketCamera.cameras;

const getCameraName= (state: IRootState, name: string): string =>
    name;



export const getCamAudio: (
    state: IRootState,
    name: string
) => ICameraLive = createSelector(
    getCameras,
    getCameraName,
    (cameras, cameraName) => {
        if (!cameras || !cameraName) {
            return {} as ICameraLive;
        }
        return cameras.filter((camera) => camera.name == cameraName).map((camera) => {
            return {sound: camera?.sound, audio: camera?.audio} as ICameraLive
        })[0]
    }
);

export const getCamImage: (
    state: IRootState,
    name: string
) => ICameraLive = createSelector(
    getCameras,
    getCameraName,
    (cameras, cameraName) => {
        if (!cameras || !cameraName) {
            return {} as ICameraLive;
        }
        return cameras.filter((camera) => camera.name == cameraName).map((camera) => {
            return {sound: camera?.sound, image: camera?.image, error: camera?.error} as ICameraLive
        })[0]
    }
);
